'use client';

import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
export var FORM_CATEGORY_WEB_CACHED = 'FORM_CATEGORY_WEB_CACHED';
export var FormCategoryWebCached = /*#__PURE__*/function () {
  function FormCategoryWebCached() {
    _classCallCheck(this, FormCategoryWebCached);

    _defineProperty(this, "mapFormCategories", new Map());
  }

  _createClass(FormCategoryWebCached, [{
    key: "getFormCategories",
    value: function () {
      var _getFormCategories = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.mapFormCategories.has(node)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this.mapFormCategories.get(node));

              case 2:
                return _context.abrupt("return", []);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getFormCategories(_x) {
        return _getFormCategories.apply(this, arguments);
      }

      return getFormCategories;
    }()
  }, {
    key: "saveFormCategories",
    value: function () {
      var _saveFormCategories = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formCategories, mode) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.mapFormCategories.set(mode, formCategories);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function saveFormCategories(_x2, _x3) {
        return _saveFormCategories.apply(this, arguments);
      }

      return saveFormCategories;
    }()
  }]);

  return FormCategoryWebCached;
}();